// transform: rotate(45deg) translate(10px, 20%) scale(1.2, 1.2) skew(10deg, 20deg);
import merge from 'lodash/merge'

let defaults = {
  node: null,
  // значения, относительно которых будет происходить трансформация.
  // например у блока изначально может быть значение transform: translate(-50%, -50%) 
  // и перемещения должны происходить как-будто-бы это значение - нетрансформированное 
  initValues: {
    translateX: '0px',   // передавать с единицей измерения, например "-50%"
    translateY: '0px',   // --//--
    scaleX: '1',         // здесь вообще нет единиц имерения
    scaleY: '1',         // --//--
  }
}

/**
 * пока-что поддерживаются только translate и scale.
 * Scale сразу сделал универсальным для обоих координат, так-что нужно работать с обеими координатами.
 */
class SmartTransformer {
  constructor(options) {
    
    this.mergedOptions = merge(defaults, options);
    if (!this.mergedOptions.node) {
      console.error('В конструктор SmartTransformer нужно обьязательно передать dom-ноду')
      return;
    }
    
    //возможно придется написать метод чтобы менять эту единицу изменерения
    this.translateUnit = 'px'
    
    this.scaleX = 1;
    this.scaleY = 1;
    this.translateX = 0;
    this.translateY = 0;
  }
  // передача параметра без единицы измерения
  setScaleX(newVal){
    this.scaleX = newVal;
  }
  // передача параметра без единицы измерения
  setScaleY(newVal){
    this.scaleY = newVal;
  }
  getScaleX(){
    return this.scaleX;
  }
  getScaleY(){
    return this.scaleY;
  }
  // передача параметра c единицой измерения. Например "10px"
  setTranslateX(newVal){
    this.translateX = newVal;
  }
  // передача параметра c единицой измерения. Например "10px"
  setTranslateY(newVal){
    this.translateY = newVal;
  }
  getTranslateX() {
    return this.translateX
  }
  getTranslateY() {
    return this.translateY
  }

  /**
   * 
   * @param node - опциональный,
   * Нужен если например с момента инициализации трансформера нода была подменена,например изображение в slick.
   * Вариант без передачи node eщё не проверен на практике.
   */
  reTransform(node){
    if (!node) node = this.mergedOptions.node; 
    let newTransformString = `
        scaleX(calc(${this.mergedOptions.initValues.scaleX} * ${this.scaleX})) 
        scaleY(calc(${this.mergedOptions.initValues.scaleY} * ${this.scaleY}))
        translateX(calc(${this.mergedOptions.initValues.translateX} + ${this.translateX}${this.translateUnit}))
        translateY(calc(${this.mergedOptions.initValues.translateY} + ${this.translateY}${this.translateUnit})) 
    `;
    node.style.transform = newTransformString;
  }
}

export default SmartTransformer


// WEBPACK FOOTER //
// ./src/JE/SmartTransformer.js